import axios from "axios";
import { servicePublisherChannelToPublisherChannel, Validation } from "../../..";
import { ObservableHandler } from "../../../handlers";
import { parseIdFilter } from "../../../handlers/filter";
import { NotImplementedError, FiltersRequiredError } from "../../../errors";
import { parseNewNewYorkApiResponse } from "../../../utils";
import { isServicePage } from "../../../handlers/page";
import { Observable } from "rxjs";
import { toQueryParams } from "./filters/params";
/**
 * Handles publisher channel find.
 * Channels are version histories of a publisher, and are thus just an array of Channels.
 */
class PublisherOrgLevelChannels extends ObservableHandler {
    constructor(sdk) {
        super(sdk, "publisher-channels");
    }
    /**
     * Find an channel based on a publisher id.
     *
     * @param filters: filter publisher channels from by a given publisher id (e.g., {where: [field: "id", type: FilterTypes.EQ, value: "1"]}).
     *          Supports (and requires):
     *              {FilterTypes.EQ, "id"}
     */
    findItems(filters) {
        const idFilter = parseIdFilter(filters);
        if (!idFilter) {
            throw new FiltersRequiredError("id");
        }
        return new Observable((subscriber) => {
            this.getChannels(filters)
                .then((channels) => {
                subscriber.next(channels);
                subscriber.complete();
            })
                .catch((error) => {
                subscriber.error(error);
            });
        });
    }
    async getChannels(filters = {}) {
        const publisherId = filters.where?.find((filter) => filter.field === "id")
            ?.value;
        if (!publisherId) {
            throw new FiltersRequiredError("publisherId");
        }
        const params = toQueryParams(filters);
        const pageSize = filters?.paging?.size || 10;
        const url = `${this.sdk.urls.baseAPIUrl}/publisher/${publisherId}/channels${params}`;
        return this.cache.promise(`${url}`, () => axios
            .get(`${url}`, {
            headers: {
                "Content-Type": "application/json"
            }
        })
            .then((res) => {
            const rawChannelData = parseNewNewYorkApiResponse(res);
            const results = rawChannelData.data;
            if (isServicePage(rawChannelData)) {
                return {
                    page: {
                        count: rawChannelData.paging_info.count,
                        token: rawChannelData.paging_info.token,
                        size: pageSize
                    },
                    data: rawChannelData.data.map(servicePublisherChannelToPublisherChannel)
                };
            }
            return results.map(servicePublisherChannelToPublisherChannel);
        })
            .catch((error) => {
            throw error;
        }));
    }
    saveItem(data) {
        return new Observable((subscriber) => {
            const payload = Array.isArray(data) ? data : [data];
            axios
                .patch(`${this.sdk.urls.baseAPIUrl}/channels`, { data: payload }, {
                headers: {
                    "Content-Type": "application/json"
                }
            })
                .then((res) => {
                const result = Array.isArray(res.data) ? res.data[0] : res.data;
                this.cache.reconcile("save", result);
                subscriber.next(result);
                subscriber.complete();
            })
                .catch((error) => {
                if (error instanceof Validation) {
                    subscriber.error(new Error(error.values().next().value));
                    return;
                }
                subscriber.error(new Error("Failed to save publisher channel"));
            });
        });
    }
    /* eslint-disable-next-line @typescript-eslint/no-unused-vars */
    make(channel) {
        throw new NotImplementedError("make");
    }
    /* eslint-disable-next-line @typescript-eslint/no-unused-vars */
    async deleteItem(id) {
        throw new NotImplementedError("delete");
    }
}
export default PublisherOrgLevelChannels;
//# sourceMappingURL=index.js.map